import { Component, HostBinding } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { EaqdbWidgetComponent } from '../quality-services-menu/eaqdb-widget.component';
import { GuaranteeRequestWidgetComponent } from '../quality-services-menu/guarantee-request-widget.component';
import { ClaimRequestWidgetComponent } from '../quality-services-menu/claim-request-widget.component';
import { AuctionWidgetComponent } from '../quality-services-menu/auction-widget.component';
import {
	CreateFastlaneWidgetComponent
} from '../../../fastlane/components/dashbord/copo-create-fastlane-widget.component';
import { CreateOrderWidgetComponent } from '../../../eorder/components/dashboard/create-order-widget.component';
import { CheckOfferWidgetComponent } from '../../../need4steel/components/dashbord/check-offer-widget.component';
import { OfferRequestWidgetComponent } from '../../../offer/components/dashboard/offer-request-widget.component';
import { CoilCalculatorWidgetComponent } from '../quality-services-menu/coil-calculator-widget.component';
import { EFeasibilityWidgetComponent } from '../../../efeasibility/components/dashboard/efeasibility-widget.component';

@Component({
	selector: 'copo-dashboard-myservice',
	templateUrl: './dashboard-myservice.component.html',
	imports: [
		TranslateModule,
		CoilCalculatorWidgetComponent,
		NgIf,
		OfferRequestWidgetComponent,
		CheckOfferWidgetComponent,
		CreateOrderWidgetComponent,
		CreateFastlaneWidgetComponent,
		AuctionWidgetComponent,
		ClaimRequestWidgetComponent,
		GuaranteeRequestWidgetComponent,
		EaqdbWidgetComponent,
		EFeasibilityWidgetComponent
	]
})
export class DashboardMyserviceComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;
	user: User;
	constructor(
		private readonly userService: UserService,
	) {
		this.user = this.userService.user;
	}
}
